module.exports = __webpack_public_path__ + "static/media/trash.008b5b6b.png";